/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const RC_COMPONENT_NAME = 'remote-config';
export const RC_CUSTOM_SIGNAL_MAX_ALLOWED_SIGNALS = 100;
export const RC_CUSTOM_SIGNAL_KEY_MAX_LENGTH = 250;
export const RC_CUSTOM_SIGNAL_VALUE_MAX_LENGTH = 500;
